export default "__VITE_ASSET__CkzwXNaQ__"